import { useIntl } from "react-intl";

const ChangeRiskAssessmentEngine = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ChangeRiskAssessmentEngine.header",
            defaultMessage: "Change risk assessment engine"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ChangeRiskAssessmentEngine.body",
            defaultMessage:
                "Score the risk of a change using a Jira automation–powered risk assessment engine."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ChangeRiskAssessmentEngine;
